import { render, staticRenderFns } from "./SyncBrandAndCampaign.vue?vue&type=template&id=8ee164e4&scoped=true&"
import script from "./SyncBrandAndCampaign.vue?vue&type=script&lang=js&"
export * from "./SyncBrandAndCampaign.vue?vue&type=script&lang=js&"
import style0 from "./SyncBrandAndCampaign.vue?vue&type=style&index=0&id=8ee164e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee164e4",
  null
  
)

export default component.exports